import React from 'react';
import { Input } from 'antd';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import { translate } from '@portal/services/i18n';
import useReduxState from '@portal/hooks/useReduxState';

interface IProps {
  qrCode: string;
  setQrCode: (value: string) => void;
  placeholder: string;
  onClean?: () => void;
  onContinue?: () => void;
}

const PaymentPixKey = ({
  qrCode,
  setQrCode,
  placeholder,
  onClean,
  onContinue,
}: IProps) => {
  const {
    theme: { currentTheme },
  } = useReduxState();
  return (
    <div className="payment-pix-key">
      <div
        className="payment-pix-key__card"
        style={{ borderTop: `4px solid ${currentTheme.borderColor}` }}
      >
        <h3 className="payment-pix-key__card__title">
          {translate('COMPONENTS.PAY_PIX.PAYMENT_PIX_KEY_TYPE')}
        </h3>
        <p className="payment-pix-key__card__text">{placeholder}</p>
        <Input.TextArea
          rows={4}
          autoFocus
          value={qrCode}
          onChange={(e) => setQrCode(e.target.value)}
          className="payment-pix-key__textarea"
          style={{ border: `2px solid ${currentTheme.borderColor}` }}
        />
        <div className="payment-pix-key__buttons">
          {onClean ? (
            <AdvancedButton
              text="Limpar"
              onClick={onClean}
              variant="outlined"
            />
          ) : null}
          {onContinue ? (
            <AdvancedButton
              text={translate('COMPONENTS.PAY_PIX.BUTTONS.CONTINUE')}
              onClick={onContinue}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PaymentPixKey;
